import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const InstallationPicturesApp = ({

}) => {
    const {
        installation,
        installations,
        citiesIndex,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
        installations: store.InstallationReducer.installationsLight,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[installation.townCode]?.name, [citiesIndex, installation])

    useTitle(() => [{
        title: i18n.installation,
        href: 'installation',
    }, {
        title: getStationTitleWithTownName(installation, townName),
        href: `station/installation/${installation?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/installation/${installation?.id}/picture`,
    }], [installation, townName])

    return (
        <PicturesApp
            stations={installations}
            station={installation}
            stationType='installation'
        />
    )
}

export default InstallationPicturesApp